import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="92"
      height="48"
      viewBox="0 0 240 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5307 128 16.1463 128 18.7607 128C86.2532 128 153.746 128 221.238 128C223.853 128 226.469 128 229.084 128C230.588 128 232.093 128 233.598 128C234.102 128 234.589 127.944 235.08 127.827C235.316 127.769 235.547 127.7 235.775 127.617C236.695 127.284 237.448 126.805 238.138 126.11C238.235 126.012 238.328 125.912 238.418 125.808C238.847 125.319 239.182 124.793 239.446 124.197C239.454 124.181 239.46 124.164 239.468 124.147C239.6 123.842 239.708 123.532 239.791 123.211C239.793 123.202 239.796 123.194 239.798 123.185C239.932 122.66 239.998 122.14 239.998 121.599C239.998 117.332 239.998 113.066 239.998 108.798C239.998 74.6664 239.998 40.5338 239.998 6.40069C239.998 2.86619 237.133 0 233.598 0C232.093 0 230.588 0 229.084 0C227.868 0 226.653 0 225.438 0C225.404 0 225.371 0 225.336 0C225.287 0 225.237 0 225.187 0C223.871 0 222.554 0 221.238 0C153.746 0 86.2532 0 18.7602 0C17.4439 0 16.1271 0 14.8108 0C14.7612 0 14.7109 0 14.6612 0C14.6274 0 14.5935 0 14.5597 0C13.345 0 12.1292 0 10.9145 0C9.40973 0 7.90496 0 6.40017 0C2.86567 0 3.33211e-07 2.86619 3.33211e-07 6.40069C3.33211e-07 40.5338 3.33211e-07 74.6664 3.33211e-07 108.798C3.33211e-07 113.066 3.33211e-07 117.332 3.33211e-07 121.599C-0.00112854 125.134 2.86624 127.998 6.40017 127.999C7.90609 128 9.41087 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.666 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.599C0.0012207 125.134 2.86629 127.999 6.40136 127.999C7.90614 127.999 9.41096 127.999 10.9157 127.999C13.5308 127.999 16.1464 127.999 18.7608 127.999C48.9209 127.999 135.079 127.999 165.239 127.999C167.854 127.999 226.469 127.999 229.084 127.999C230.589 127.999 232.093 127.999 233.598 127.999C234.102 128 234.589 127.942 235.08 127.826C235.316 127.769 235.547 127.7 235.775 127.617C236.695 127.284 237.448 126.805 238.138 126.11C238.235 126.012 238.329 125.912 238.419 125.808C238.847 125.318 239.183 124.793 239.446 124.197C239.454 124.181 239.461 124.164 239.469 124.147C239.6 123.842 239.708 123.532 239.791 123.211C239.793 123.202 239.796 123.194 239.798 123.185C239.932 122.66 239.998 122.14 239.998 121.599C239.998 117.332 239.998 113.066 239.998 108.798C239.998 108.665 239.998 108.533 239.998 108.399H0.0012207V108.4Z"
        fill="url(#paint0_linear_6150_22614)"
      />
      <path
        opacity="0.2"
        d="M19.6013 0.000549316C19.3213 0.000549316 19.0413 0.000549316 18.7614 0.000549316C17.4451 0.000549316 16.1283 0.000549316 14.812 0.000549316C14.7623 0.000549316 14.7121 0.000549316 14.6625 0.000549316C14.6286 0.000549316 14.5947 0.000549316 14.5608 0.000549316C13.3456 0.000549316 12.1304 0.000549316 10.9157 0.000549316C9.41096 0.000549316 7.90614 0.000549316 6.40136 0.000549316C2.86629 0.000549316 0.0012207 2.86674 0.0012207 6.40123C0.0012207 40.5344 0.0012207 74.6658 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.599C0.0012207 125.134 2.86629 127.999 6.40136 127.999C7.90614 127.999 9.41096 127.999 10.9157 127.999C13.5308 127.999 16.1464 127.999 18.7608 127.999C19.0408 127.999 19.3207 127.999 19.6007 127.999V0.000549316H19.6013Z"
        fill="url(#paint1_linear_6150_22614)"
      />
      <path
        opacity="0.2"
        d="M220.399 0.000549316C220.679 0.000549316 220.958 0.000549316 221.238 0.000549316C222.555 0.000549316 223.872 0.000549316 225.188 0.000549316C225.238 0.000549316 225.287 0.000549316 225.337 0.000549316C225.371 0.000549316 225.405 0.000549316 225.439 0.000549316C226.654 0.000549316 227.87 0.000549316 229.084 0.000549316C230.589 0.000549316 232.094 0.000549316 233.599 0.000549316C237.133 0.000549316 239.998 2.86674 239.998 6.40123C239.998 40.5344 239.998 74.6658 239.998 108.799C239.998 113.067 239.998 117.333 239.998 121.599C239.998 125.134 237.133 127.999 233.599 127.999C232.094 127.999 230.589 127.999 229.084 127.999C226.469 127.999 223.854 127.999 221.239 127.999C220.959 127.999 220.679 127.999 220.399 127.999V0.000549316H220.399Z"
        fill="url(#paint2_linear_6150_22614)"
      />
      <path
        d="M19.8565 19.6006C19.6759 19.6006 19.6008 19.6756 19.6008 19.8568C19.6008 49.2859 19.6008 78.7145 19.6008 108.144C19.6008 108.325 19.6759 108.4 19.8565 108.4C49.2856 108.4 78.7142 108.4 108.143 108.4C108.324 108.4 108.399 108.325 108.399 108.144C108.399 78.7145 108.399 49.2859 108.399 19.8568C108.399 19.6756 108.324 19.6006 108.143 19.6006C78.7142 19.6006 49.2856 19.6006 19.8565 19.6006Z"
        fill="#575756"
      />
      <path
        d="M107.999 107.743C107.999 107.925 107.924 108 107.743 108C78.581 108 49.4188 108 20.2567 108C20.076 108 20.001 107.925 20.001 107.743C20.001 78.5813 20.001 49.4191 20.001 20.2564C20.001 20.0758 20.076 20.0007 20.2567 20.0007C49.4188 20.0007 78.581 20.0007 107.743 20.0007C107.924 20.0007 107.999 20.0758 107.999 20.2564C107.999 49.4191 107.999 78.5813 107.999 107.743Z"
        fill="#E3E3E3"
      />
      <path
        d="M98.004 97.854C98.004 97.5136 97.868 97.3668 97.5237 97.3668C96.5246 97.3668 95.5267 97.3668 94.5282 97.3668C94.5282 97.0937 94.5282 96.8199 94.5282 96.5467C94.5282 95.9518 94.2274 95.5466 93.9508 95.0843C93.0071 93.5106 92.8332 91.6897 94.7884 90.8527C96.4631 90.1353 98.3257 91.3703 98.3274 93.1906C98.3274 93.3447 98.3122 93.4948 98.2794 93.6455C98.2089 93.978 98.3201 94.1428 98.6503 94.215C98.9833 94.2873 99.1509 94.1784 99.2187 93.8442C99.8074 91.0711 96.8977 88.8371 94.3385 90.0021C93.151 90.5428 92.3562 91.7016 92.2879 93.0066C92.2524 93.6839 92.4189 94.254 92.7158 94.8489C92.9258 95.2689 93.5681 95.9835 93.5681 96.5473C93.5681 97.2884 93.5681 98.0306 93.5681 98.7717C93.5681 99.1115 93.7086 99.2521 94.0484 99.2521C94.2228 99.2521 94.3967 99.2521 94.5711 99.2521C94.5711 99.4 94.5711 99.5479 94.5711 99.6958C94.5711 100.036 94.7116 100.176 95.0514 100.176C95.5414 100.176 96.0313 100.176 96.5212 100.176C96.861 100.176 97.0016 100.036 97.0016 99.6958C97.0016 99.5479 97.0016 99.4 97.0016 99.2521C97.176 99.2521 97.3498 99.2521 97.5242 99.2521C97.864 99.2521 98.0045 99.1115 98.0045 98.7717C98.004 98.4652 98.004 98.1599 98.004 97.854Z"
        fill="#575756"
      />
      <path
        d="M63.437 28.6406C63.437 52.2137 63.437 75.7862 63.437 99.3599C63.437 99.7578 63.6018 99.9227 64.0003 99.9227C64.3988 99.9227 64.5631 99.7578 64.5631 99.3599C64.5631 75.7862 64.5631 52.2137 64.5631 28.6406C64.5631 28.2421 64.3988 28.0779 64.0003 28.0779C63.6018 28.0779 63.437 28.2421 63.437 28.6406Z"
        fill="#B2B2B2"
      />
      <path
        d="M34.3541 97.854C34.3541 97.5131 34.2181 97.3669 33.8738 97.3669C32.8747 97.3669 31.8768 97.3669 30.8783 97.3669C30.8783 97.0937 30.8783 96.8199 30.8783 96.5467C30.8783 95.9512 30.5774 95.546 30.3009 95.0838C29.3571 93.5101 29.1833 91.6892 31.1385 90.8527C32.8132 90.1353 34.6753 91.3698 34.6775 93.1901C34.6775 93.3442 34.6623 93.4942 34.6295 93.6455C34.559 93.9774 34.6702 94.1423 35.0004 94.2145C35.3334 94.2873 35.501 94.1778 35.5687 93.8442C36.1575 91.0706 33.2478 88.8366 30.6886 90.0016C29.5011 90.5423 28.7063 91.7011 28.638 93.006C28.6025 93.6839 28.769 94.254 29.0659 94.8484C29.2759 95.2683 29.9182 95.9829 29.9182 96.5473C29.9182 97.2885 29.9182 98.0301 29.9182 98.7717C29.9182 99.111 30.0587 99.2515 30.3985 99.2515C30.5729 99.2515 30.7468 99.2515 30.9212 99.2515C30.9212 99.3994 30.9212 99.5473 30.9212 99.6958C30.9212 100.035 31.0617 100.176 31.4015 100.176C31.8915 100.176 32.3814 100.176 32.8713 100.176C33.2105 100.176 33.3517 100.035 33.3517 99.6958C33.3517 99.5473 33.3517 99.3994 33.3517 99.2515C33.5261 99.2515 33.6999 99.2515 33.8743 99.2515C34.2141 99.2515 34.3546 99.111 34.3546 98.7717C34.3541 98.4653 34.3541 98.1599 34.3541 97.854Z"
        fill="#575756"
      />
      <path
        d="M219.998 107.743C219.998 107.925 219.923 108 219.742 108C190.58 108 161.418 108 132.256 108C132.075 108 132 107.925 132 107.743C132 78.5813 132 49.4192 132 20.2564C132 20.0758 132.075 20.0007 132.256 20.0007C161.418 20.0007 190.58 20.0007 219.742 20.0007C219.923 20.0007 219.998 20.0758 219.998 20.2564C219.998 49.4192 219.998 78.5813 219.998 107.743Z"
        fill="#E3E3E3"
      />
      <path
        d="M219.745 20.0009C219.925 20.0009 220 20.076 220 20.2566C220 49.4195 220 78.5818 220 107.744C220 107.925 219.925 108 219.745 108C190.582 108 161.419 108 132.257 108C132.077 108 132.001 107.925 132.001 107.744C132.001 78.5818 132.001 49.4195 132.001 20.2566C132.001 20.076 132.077 20.0009 132.257 20.0009"
        fill="#E3E3E3"
      />
      <path
        d="M132.256 20C132.075 20 132 20.0751 132 20.2562C132 49.6855 132 79.1142 132 108.543C132 108.724 132.075 108.799 132.256 108.799C161.685 108.799 191.114 108.799 220.543 108.799C220.725 108.799 220.799 108.724 220.799 108.543C220.799 79.1142 220.799 49.6855 220.799 20.2562C220.799 20.0751 220.725 20 220.543 20C191.114 20 161.684 20 132.256 20Z"
        fill="#575756"
      />
      <path
        d="M220.143 20.6559V20.4002H132.656"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.143 20.4002C220.324 20.4002 220.399 20.4753 220.399 20.6559C220.399 49.8187 220.399 78.981 220.399 108.143C220.399 108.324 220.324 108.399 220.143 108.399C190.98 108.399 161.818 108.399 132.656 108.399C132.475 108.399 132.4 108.324 132.4 108.143C132.4 78.981 132.4 49.8187 132.4 20.6559C132.4 20.4753 132.475 20.4002 132.656 20.4002"
        fill="#E3E3E3"
      />
      <path
        d="M176.399 95.2786C193.453 95.2786 207.279 81.4535 207.279 64.3993C207.279 47.3452 193.453 33.52 176.399 33.52C159.345 33.52 145.52 47.3452 145.52 64.3993C145.52 81.4535 159.345 95.2786 176.399 95.2786Z"
        fill="url(#paint3_linear_6150_22614)"
      />
      <path
        d="M161.04 68.9594C163.558 68.9594 165.6 66.9178 165.6 64.3993C165.6 61.8808 163.558 59.8392 161.04 59.8392C158.521 59.8392 156.48 61.8808 156.48 64.3993C156.48 66.9178 158.521 68.9594 161.04 68.9594Z"
        fill="#3C3C3B"
      />
      <path
        d="M191.759 68.9594C194.278 68.9594 196.319 66.9178 196.319 64.3993C196.319 61.8808 194.278 59.8392 191.759 59.8392C189.241 59.8392 187.199 61.8808 187.199 64.3993C187.199 66.9178 189.241 68.9594 191.759 68.9594Z"
        fill="#3C3C3B"
      />
      <path
        d="M209.068 98.422C208.656 98.8352 208.656 99.5046 209.068 99.9178C209.482 100.332 210.149 100.329 210.562 99.9166C210.976 99.5046 210.977 98.8352 210.564 98.422C210.15 98.01 209.481 98.01 209.068 98.422Z"
        fill="#575756"
      />
      <path
        d="M206.053 98.6901C205.321 98.6901 204.588 98.6901 203.856 98.6901C203.727 98.6901 203.675 98.637 203.675 98.5083C203.675 96.7433 203.675 94.9783 203.675 93.2133C203.675 93.0841 203.728 93.0316 203.856 93.0316C205.621 93.0316 207.386 93.0316 209.151 93.0316C209.28 93.0316 209.333 93.0846 209.333 93.2133C209.333 93.9454 209.333 94.6775 209.333 95.4107C209.333 95.7505 209.473 95.8905 209.813 95.8905C210.153 95.8905 210.294 95.7505 210.294 95.4107C210.294 94.6775 210.294 93.9454 210.294 93.2133C210.293 92.5828 209.782 92.0726 209.152 92.0715C207.387 92.0715 205.622 92.0715 203.857 92.0715C203.226 92.0715 202.715 92.5828 202.715 93.2133C202.715 94.9783 202.715 96.7433 202.715 98.5083C202.715 99.1388 203.226 99.6502 203.857 99.6502C204.589 99.6502 205.321 99.6502 206.053 99.6502C206.392 99.6502 206.533 99.5102 206.533 99.1704C206.533 98.8307 206.391 98.6901 206.053 98.6901Z"
        fill="#575756"
      />
      <path
        d="M179.519 41.999V33.6871C178.488 33.5816 177.447 33.5195 176.399 33.5195C175.347 33.5195 174.306 33.5731 173.28 33.6758V41.9984H179.519V41.999Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.999 59.7094C149.999 55.9304 149.999 52.151 149.999 48.3721C147.854 51.8987 146.403 55.8915 145.817 60.1592C147.061 60.1592 148.305 60.1592 149.55 60.1592C149.867 60.1592 149.999 60.0283 149.999 59.7094Z"
        fill="#D0D0D0"
      />
      <path
        d="M203.293 60.1592C204.524 60.1592 205.755 60.1592 206.987 60.1592C206.979 60.1062 206.972 60.0526 206.964 59.9995C206.956 59.9464 206.948 59.8928 206.941 59.8398C206.351 55.8921 205.12 52.3739 203.119 48.9201C203.018 48.7457 202.903 48.5792 202.799 48.4076C202.799 52.16 202.799 55.9141 202.799 59.6665C202.799 60.0148 202.944 60.1592 203.293 60.1592Z"
        fill="#D0D0D0"
      />
      <path
        d="M173.279 86.799V95.1223C174.305 95.225 175.346 95.2786 176.399 95.2786C177.452 95.2786 178.493 95.2245 179.519 95.1223V86.799H173.279Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.473 68.6394C148.255 68.6394 147.036 68.6394 145.817 68.6394C146.403 72.9082 147.854 76.9 149.999 80.4266C149.999 76.6731 149.999 72.9201 149.999 69.1665C149.999 68.7934 149.845 68.6394 149.473 68.6394Z"
        fill="#D0D0D0"
      />
      <path
        d="M203.411 68.6394C202.978 68.6394 202.799 68.8189 202.799 69.2501C202.799 72.9765 202.799 76.7013 202.799 80.4266C204.945 76.9 206.395 72.9082 206.982 68.6394C205.792 68.6394 204.601 68.6394 203.411 68.6394Z"
        fill="#D0D0D0"
      />
      <path
        d="M174.502 95.2086C175.132 95.2493 175.764 95.2792 176.399 95.2792C177.037 95.2792 177.667 95.2527 178.296 95.2143V85.6708H174.501V95.2086H174.502Z"
        fill="url(#paint4_linear_6150_22614)"
      />
      <path
        d="M178.296 33.5906C177.666 33.5494 177.035 33.52 176.399 33.52C175.761 33.52 175.131 33.546 174.503 33.5844V43.1279H178.297V33.5906H178.296Z"
        fill="url(#paint5_linear_6150_22614)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6150_22614"
          x1="120"
          y1="109.076"
          x2="120"
          y2="127.439"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6150_22614"
          x1="16.56"
          y1="63.9997"
          x2="0.309177"
          y2="63.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6150_22614"
          x1="223.44"
          y1="63.9997"
          x2="239.69"
          y2="63.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6150_22614"
          x1="176.399"
          y1="95.2791"
          x2="176.399"
          y2="33.5199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6150_22614"
          x1="176.4"
          y1="95.1468"
          x2="176.4"
          y2="85.6417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6150_22614"
          x1="176.399"
          y1="33.6522"
          x2="176.399"
          y2="43.1566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
